module.exports = __webpack_public_path__ + "assets/images/fountain-01.7a99c16b0052ab2bbf0cea2af06fca2d.svg";